import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyBenefitForm } from '@app/modules/forms/payroll/components';
import { AuthService, NotifyService } from '@app/services';
import { BenefitType } from '@models/payroll/benefit-type.model';
import { CompanyBenefit } from '@models/payroll/company/benefit.model';

@Component({
    templateUrl: './benefit-store.template.html',
})
export class BenefitStoreView {
    isLoading = false;
    title = 'payroll.benefits.createABenefit';
    benefit: CompanyBenefit = new CompanyBenefit();
    benefitType?: BenefitType;

    constructor(
        private router: Router,
        public route: ActivatedRoute,
        private notify: NotifyService,
        private auth: AuthService
    ) {
        if (this.route.snapshot.data.models) {
            this.title = 'payroll.benefits.editBenefitDetails';
            this.benefit = this.route.snapshot.data.models.get('benefit');

            this.benefit.benefitTypeId = this.benefit.benefitType?.id;
            this.onBenefitTypeChanged(this.benefit.benefitTypeId);
        }
    }

    get shouldShowBox52Warning(): boolean {
        if (this.benefitType === undefined) return false;
        return ['defined_benefit_pension_plan'].includes(this.benefitType?.name);
    }

    async onBenefitTypeChanged(benefitTypeId: number): Promise<void> {
        this.benefitType = await BenefitType.with('t4_boxes').find(benefitTypeId);
    }

    getBackRoute(): string[] {
        return this.benefit.isPersisted ? ['/payroll', 'benefits', String(this.benefit.id)] : ['/payroll', 'benefits'];
    }

    cancel(event: MouseEvent): void {
        event.preventDefault();
        this.router.navigate(this.getBackRoute());
    }

    async save(form: CompanyBenefitForm): Promise<void> {
        form.submit();

        if (form.form.invalid) {
            return;
        }

        this.isLoading = true;

        try {
            await this.benefit.param('company', this.auth.company.id).save();
            this.router.navigate(['..'], { relativeTo: this.route });
            this.notify.success('saved');
        } catch (err) {
            this.notify.error(err);
        }

        this.isLoading = false;
    }
}
